import style from "./Components/form.module.scss";

import TextInput from "./Components/TextInput";
import SelectInput from "./Components/SelectInput";
import ImageUploader from "./Components/ImageUploader/ImageUploader";
import TextArea from "./Components/TextArea";

import { useEffect, useState } from "react";
import { domain } from "config.js";


import MessageBox from "Common/MessageBox";

var uploadFolder;

let dataId = "";
let addAsNew = false;

function Form({ className, tarfol, mode, data }) {
    const [options, setOptions] = useState({});
    const [curRegion, setCurRegion] = useState("");
    const [allowEntry, setAllowEntry] = useState(true);

    const [retrySave, setRetrySave] = useState(0);
    const [retryNeeded, setRetryNeeded] = useState(false);
    const [retryEnabled, setRetryEnabled] = useState(false);

    const [f_region, setF_Region] = useState("");
    const [f_location, setF_Location] = useState("");
    const [f_type, setF_Type] = useState("");
    const [f_bedrooms, setF_Bedrooms] = useState("");
    const [f_price, setF_Price] = useState("");
    const [f_description, setF_Description] = useState("");

    const [message, setMessage] = useState(false);
    // const [clear, setClear] = useState(false);

    uploadFolder = `uploadto/${tarfol}`;


    useEffect(() => {
        async function loadOptions() {
            setOptions(await (await fetch(`${domain}/int-getSearchOptions`)).json());
        }
        loadOptions();
    }, [])

    useEffect(() => {
        if (mode !== "edit") return;
        const iid = Object.keys(data)[0];
        const vals = Object.values(data)[0];

        dataId = iid;

        setF_Region(vals.region);
        setF_Location(vals.location);
        setF_Type(vals.type);
        setF_Bedrooms(vals.bedrooms);
        setF_Price(vals.price);
        setF_Description(vals.description);

        loadLocation(vals.region)

    }, [data, options])

    // useEffect(()=>{
    //     if (!clear) return;
    //     clearForm();
    //     setClear(false);
    // }, [clear]);

    function loadLocation(value) {
        setCurRegion(value);
    }

    function submitForm(e) {
        e.preventDefault();
        e.stopPropagation();

        addAsNew = e.nativeEvent.submitter.id === "addAsNew";

        if (mode === "edit") return completed();

        if (allowEntry)
            setAllowEntry(false);
        else {
            setRetrySave(1 + Math.random());
            setRetryEnabled(false);
        }
    }


    function clearForm() {
        if (mode === "edit") return;
        setF_Region("");
        setF_Location("");
        setF_Type("");
        setF_Bedrooms("");
        setF_Price("");
        setF_Description("");
    }

    async function completed() {
        // console.log("Completing...");
        var id;
        try {
            id = await submitData();
        } catch (e) {
            console.log(e);
        }

        if (id) {
            setRetryNeeded(false);
            setMessage({ message: `Successfully ${(mode !== "edit") ? "added a new" : (addAsNew ? "added the changes as a new" : "updated the")} property !`, type: 1 });
            clearForm();
            setAllowEntry(true);
            if (retrySave > 0) setRetrySave(0);
        } else {
            setRetryNeeded(true);
            setRetryEnabled(true);
            setMessage({ message: `Unable to ${(mode !== "edit") ? "add" : "edit"} property !`, type: -1 });
        }
    }

    async function submitData() {
        var params = {};
        params.region = f_region;
        params.location = f_location;
        params.type = f_type;
        params.bedrooms = f_bedrooms;
        params.price = f_price;
        params.description = f_description;
        params.uploadFolder = uploadFolder;
        if (mode === "edit") {
            params.id = dataId;
        }

        var success;

        console.log("ADDASNEW", addAsNew);

        let data = {};
        if ((mode === "edit") && (!addAsNew)) {
            data = {
                endpoint: "editProperty",
                body: { [dataId]: params }
            };
        } else {
            data = {
                endpoint: "addProperty",
                body: params
            };

        }

        await fetch(domain + "/int-" + data.endpoint, { method: "POST", body: JSON.stringify(data.body) }).then(async response => {
            await response.json().then(data => {
                success = data?.success;
            })
        })

        return success;

    }

    if (mode === "edit" && Object.keys(options).length === 0) return <h3 style={{ margin: "100px 0" }}>loading...</h3>;

    return (
        <form className={`${className} ${style.entry_form}`} onSubmit={submitForm}>

            {message ? <MessageBox success={true} message={message} setMessage={setMessage} /> : ""}


            <div>
                <br />
                <h4>{mode === "edit" ? "Edit" : "Add new"} property </h4>
            </div>

            <SelectInput valueState={{ value: f_region, setValue: setF_Region }} label="Region" options={options.regions ? Object.keys(options.regions) : []} onChange={loadLocation} allowEntry={allowEntry} />
            <SelectInput valueState={{ value: f_location, setValue: setF_Location }} label="Location" options={options.regions ? options.regions[curRegion] : []} allowEntry={allowEntry} />
            <SelectInput valueState={{ value: f_type, setValue: setF_Type }} label="Type" options={options.types} allowEntry={allowEntry} />
            <SelectInput valueState={{ value: f_bedrooms, setValue: setF_Bedrooms }} label="Bedrooms" options={options.bedrooms} allowEntry={allowEntry} />

            <TextInput valueState={{ value: f_price, setValue: setF_Price }} label="Price" type="number" allowEntry={allowEntry} />

            <TextArea valueState={{ value: f_description, setValue: setF_Description }} label="Description" allowEntry={allowEntry} />


            {(mode !== "edit") && <div>
                <br />
                <div style={{ fontSize: "14pt" }}>Upload Image of the property here </div>
                <br />
            </div>}
            {(mode !== "edit") && <ImageUploader allowEntry={allowEntry} setAllowEntry={setAllowEntry} completed={completed} clearForm={clearForm} retrySave={retrySave} uploadFolder={uploadFolder} />}

            <div className={style.buttonsCnt}>
                {(!(retryNeeded && addAsNew)) && <button className="btn btn-primary s" style={{ transform: "scale(1.2)" }} disabled={(!allowEntry && !retryEnabled)}> {(!retryNeeded) ? "Save Changes" : "Try Again"} </button>}
                {(mode === "edit") && <button id="addAsNew" className={" btn s " + style.addAsNew} style={{ transform: "scale(1.2)" }} disabled={(!allowEntry && !retryEnabled)}> {(!retryNeeded) ? "Add as another" : "Try Again"} </button>}
            </div>
        </form >
    );
}

export default Form;